<template>
	<div>
		<b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="addModal" id="addModal" :title="title" size="lg" @ok="ok" @hidden="hidden" @cancel="cancel" :ok-disabled="this.$store.state.ajax_in_progress">
			<div class="row">
				<div class="col-lg-12">
					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.revision_number') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.revision_number">
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.date') }}</label>
						</div>
						<div class="col-lg-8">
							<flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.revision_date"></flat-pickr>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.description') }}</label>
						</div>
						<div class="col-lg-8">
							<textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_description"></textarea>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.revision_reason') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="model.revision_reason_setting"
								:options="currentProgress"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isLoading"
								:preserve-search="true"
								placeholder=""
								label="value" track-by="id"
								:selectLabel="''"
								@search-change="onSearchProjectSetting"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.revision_reason_setting != null && typeof model.revision_reason_setting.id != 'undefined' && model.revision_reason_setting.id != null"  
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProjectSetting"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.remarks') }}</label>
						</div>
						<div class="col-lg-8">
							<textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_remarks"></textarea>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Multiselect from 'vue-multiselect';

export default {
	name: 'RevisionControlModal',
	components: {
		flatPickr,
		Multiselect,
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		settingType: {
			type: String,
			required: true
		},
		model: {
			type: Object,
			default: () => ({
				revision_number: null,
				revision_remarks: null,
				revision_reason: null,
				revision_description: null,
				revision_date: null,
				revision_reason_setting: null,
			})
		}
	},
	mounted() {
	},
	data() {
		return {
			currentProgress: [],
			isLoading: false,
		}
	},
	methods: {
		ok(e) {
			e.preventDefault();
			this.$emit("ok", e);
		},
		cancel() {
			this.$emit("cancel");
		},
		hidden() {
			this.$emit("hidden");
		},
		show() {
			this.errors.clear();
			this.$refs.addModal.show();
		},
		hide() {
			this.$refs.addModal.hide();
		},
		onSearchProjectSetting(search) {
			if (search == '') {
                this.currentProgress = [];
                
                return false;
            }
			
			this.isLoading = true;
			this.searchProjectSetting(search, this);
		},
		searchProjectSetting: _.debounce((search, vm) => {
			let data = http.route("projectsetting?project_id=" + vm.$route.params.id + "&filters[type]=" + vm.settingType + "&get_all=1&search_select=" + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentProgress = response.data;
				}
				vm.isLoading = false;
			});
		}, 500),
		clearSelectedProjectSetting () {
			this.model.revision_reason_setting = null;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/global/modals/RevisionControlModal.vue